module.exports = __webpack_public_path__ + "img/biz_logo_ES.3127c503.png";